import OrderService from "../../services/orders/OrderService";
import serviceForceShippingFee from "../../services/force-shipping-fee/ForceShippingFeeService";
import CheckInOrderService from '../../services/orders/CheckInOrderService'
import i18n from "../../i18n/index";
import JSZip from "jszip";
import * as moment from 'moment';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import axios from 'axios';
import url from "socket.io-client/lib/url";



export default {
  components: {
},
    props: ["status", "providerId", "enabledColumns"],
    data() {
        return {
            step: 1,
            imagenmodalsupor:[],
            arrayimagen:[],
            occ: 0,
            onboarding: 0,
          campos: [
            {id: 1, fruit: 'Apple', price: 4.50, unit: 'lb'},
            {id: 2, fruit: 'Blueberry', price: 3.00, unit: 'lb'},
            {id: 3, fruit: 'Pineapple', price: 5.15, unit: 'each'},
        ],
        fields: ['fruit', 'price', 'unit'],
          imagenn: false,
            showText: true,
            dataPicker: false,
            date: '',
            date2: '',
            search: "",
            showInput: false,
            headers: [{
                id: 0,
                text: i18n.t('headers.date-delivery'),
                sortable: false,
                value: "fecha_entrega"
            },
            {
                id: 1,
                text: i18n.t('headers.nro-order'),
                sortable: false,
                value: "orden"
            },
            {
                id: 2,
                text: i18n.t('headers.patient-document'),
                sortable: false,
                value: "patient_document"
            },
            {
                id: 3,
                text: i18n.t('headers.patient-name-user'),
                sortable: false,
                value: "documento"
            },
            {
              id: 4,
              text: i18n.t('headers.patient-name-support'),
              sortable: false,
              value: "usuario"
          },
            
            {
                id: 5,
                text: i18n.t('headers.status-order'),
                value: "estado",
                sortable: false
            },
            {
                id: 8,
                text: i18n.t('headers.options'),
                value: "hasPending",
                sortable: false
            }
               
            ],
            orders: [],
            totalOrders: 0,
            loading: false,
            pagination: {},
            selectedItem: {},
            rowsPerPageItems: [5, 10, 15, 20],
            code: '',
            searchTypes: ['Documento','Número de pedido', 'Nombre del paciente', 'Tipo de usuario','Nombre de soporte'],
            searchUserTypes: ['POS', 'Póliza', 'Consentido'],
            searchType: 'Documento',
            searchUserType: 'POS',
            minDate: moment().format('YYYY-MM-DD'),
            url:"https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
            urls:"https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
            nuevasImagenes:[],
                
            
        };
    },
    computed: {
        customHeaders() {
            return this.enabledColumns ? this.headers.filter(header => this.enabledColumns[header.id]) : this.headers
        }
    },
    mounted() {
        // this.focusInput();
        this.showInputSearchInvoice();
    },
    watch: {
        pagination: {
            handler() {
                this.getOrders();
            },
            deep: true
        }
    },
    methods: {
        next () {
            console.log("next",this.onboarding)
            console.log(this.arrayimagen.length)
            this.onboarding = this.onboarding + 1 === this.occ
              ? 0
              : this.onboarding + 1
          },
          prev () {
            console.log("atras",this.onboarding)
            console.log(this.arrayimagen.length)
            this.onboarding = this.onboarding - 1 < 0
              ? this.occ - 1
              : this.onboarding - 1
          },
      clickimagen(datos,state){
        this.imagenn=state;
        this.arrayimagen=[];
        this.nuevasImagenes=[];
        this.occ=1;
        this.onboarding=0;
        console.log("===>",datos[0]['fileType']);
        for(var i = 0; i < datos.length;i++){
                
                console.log("--------->",datos)
                const arrFront = new Uint8Array(datos[i]['data']['data']);
            let typeString = "";
            switch (datos[i]['fileType']) {
                case "jpg":
                typeString = "image/jpeg";
                break;
                case "jpeg":
                typeString = "image/jpeg";
                break;
                case "png":
                typeString = "image/png";
                break;
                case "pdf":
                typeString = "application/pdf";
                break;
                default:
                break;
            }
            const blobFront = new Blob([arrFront], { type: typeString });

            this.nuevasImagenes.push(blobFront);

            let fileURLFront = window.URL.createObjectURL(blobFront);
            console.log("bloooob ==>>>",fileURLFront);
            this.arrayimagen.push({
                fileName:datos[i]['fileName'],
                imageFront: fileURLFront,
            })
          //  console.log("arrayimg =>>>>",fileURLFront);
            }
            this.occ=datos.length;
      console.log("lo ultimo",this.arrayimagen)
      },
      imagenclick(datos,state){
        this.imagenn=state;
        this.occ=1;
        console.log("===>",datos[0]['fileType']);
        for(var i = 0; i < datos.length;i++){
                
                console.log("--------->",datos)
                const arrFront = new Uint8Array(datos[i]['data']['data']);
            let typeString = "";
            switch (datos[i]['fileType']) {
                case "jpg":
                typeString = "image/jpeg";
                break;
                case "jpeg":
                typeString = "image/jpeg";
                break;
                case "png":
                typeString = "image/png";
                break;
                case "pdf":
                typeString = "application/pdf";
                break;
                default:
                break;
            }
            const blobFront = new Blob([arrFront], { type: typeString });

            this.nuevasImagenes.push(blobFront);

            let fileURLFront = window.URL.createObjectURL(blobFront);
            console.log("bloooob ==>>>",fileURLFront);
            this.arrayimagen.push({
                fileName:datos[i]['fileName'],
                imageFront: fileURLFront,
            })
          //  console.log("arrayimg =>>>>",fileURLFront);
            }
            this.occ=datos.length;
      console.log("lo ultimo",this.arrayimagen)
      },
      async exportImagesAsZip(datos,all= false)  {
        this.arrayimagen=[];
        this.nuevasImagenes=[];
        const zip = new JSZip();
        if(!all ){
        this.imagenclick(datos,false);
        var img = zip.folder("images");
                var i = 0;
                this.nuevasImagenes.forEach((blob, index) => {
                var name = this.arrayimagen[i]['fileName'];
                console.log("BLOB ===>",name);
                img.file(`${name}.jpg`, blob, { binary: true });
                i++;
                });
            
                zip.generateAsync({ type: 'blob' })
                .then(content => {
                    saveAs(content, 'archivos.zip');
                })
                .catch(error => {
                    console.error('Error al generar el archivo ZIP:', error);
                });
        }else{
            if(datos.length > 0){
                for(var h = 0; h < datos.length; h++){
                    console.log("datos ===>",datos[h]["files"]);
                    this.imagenclick(datos[h]["files"],false);
                        
                }
                const content = "UEsDBAoAAAAAAI5ONE9i6ZVwCQAAAAkAAAAIAAAAdGVzdC50eHRUZXN0IGZpbGVQSwECPwAKAAAAAACOTjRPYumVcAkAAAAJAAAACAAkAAAAAAAAACAAAAAAAAAAdGVzdC50eHQKACAAAAAAAAEAGABz76T2f2/VAXPvpPZ/b9UB1NBncjhp1QFQSwUGAAAAAAEAAQBaAAAALwAAAAAA"; // base64 content without mimeType

     
   
        var csvData = [
            ['FECHA ENTREGA', 'N-PEDIDO','DOCUMENTO','NOMBRE USUARIO','NOMBRE SOPORTE','ESTADO PEDIDO'] ];



            for(var d = 0; d < datos.length; d++){

                var imgname = [];
                console.log("all====>",datos[d]['files']);
                for(var j = 0; j < datos[d]['files'].length; j++){
                    console.log("name image ==>",datos[d]['files'][j]);
                    imgname.push(datos[d]['files'][j]['fileName'])
                }

                console.log("imagenes",imgname);

                csvData.push(
                    [
                        datos[d].fecha_entrega.slice(0,10) 
                    , datos[d]['orden']
                    ,datos[d]['documento']
                    ,datos[d]['usuario']
                    ,imgname.join(" * ") //datos[d]['']
                    ,datos[d]['estado']
                ] 
                )
            }

                var csv = "";-
                csvData.forEach(function(row) {  
                    csv += row.join(';');  
                    csv += "\n";  
                });
                var csvFile = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                var csvFile = csvData.map(e => e.join(";    ")).join("\n");

                zip.file("Datos.csv", csvFile);
                var img = zip.folder("images");
                var i = 0;
                this.nuevasImagenes.forEach((blob, index) => {
                var name = this.arrayimagen[i]['fileName'];
                console.log("BLOB ===>",name);
                img.file(`${name}.jpg`, blob, { binary: true });
                i++;
                });
            
                zip.generateAsync({ type: 'blob' })
                .then(content => {
                    saveAs(content, 'Soporte_entrega_pedidos.zip');
                })
                .catch(error => {
                    console.error('Error al generar el archivo ZIP:', error);
                });
            }
            else{
                alert("hola")
            }
        }

      },
      closed(){
        this.imagenn=false;
      },
      async  download(url,name){
        console.log('downloading', url);
        const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = () => {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(xhr.response);
        const link = document.createElement("a");
        link.href = imageUrl;
        link.setAttribute("download", name);
        link.setAttribute("target", "new");
        document.body.appendChild(link);
        link.click();
      };
      xhr.open("GET", url);
      xhr.send();
      console.log('downloading', url);
      },
     
     
        showColumn(i) {
            return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
        },
        getOrders() {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            if (this.date !== null & this.date !== undefined && this.date !== '') { 
                if (this.date2 === null || this.date2 === undefined || this.date2 === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha final'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') { 
                if (this.date === null || this.date === undefined || this.date === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha inicial'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date === null || this.date === undefined) {
                this.date = ''
            }
            if (this.date2 === null || this.date2 === undefined) {
                this.date2 = ''
            }
            
            let searchTypeAux = ''
            if (this.searchType === 'Documento') {
                searchTypeAux = 'Identification'
            } else if (this.searchType === 'Nombre de soporte') {
                searchTypeAux = 'NameImage'
            } else if (this.searchType === 'Número de pedido') {
                searchTypeAux = 'Order'
            } else if (this.searchType === 'Nombre del paciente') {
                searchTypeAux = 'NamePatient'
            }else if (this.searchType === 'Tipo de usuario'){
                searchTypeAux = 'typeUserOrder';     
                this.search =  this.search == 'Póliza' ? '8' : this.search == 'Consentido' ? '9' : this.search == 'POS' ? '7' : null; 
            }
            serviceForceShippingFee.getsupport(
                page * 1,
                rowsPerPage,
                this.search,
                this.date,
                this.date2,
                searchTypeAux
            ).then(data => {
                this.loading = false;
                console.log("data",data['data'][0])
                this.orders=data['data'][0].map(x=>{
                    x.fecha_entrega,
                    x.orden,
                    x.documento,
                    x.usuario,
                    x.files,
                    x.estado
                    if(x.estado == 'RETURNED'){
                        x.estado = 'DEVUELTO'
                      }else if(x.estado == 'SCHEDULED'){
                        x.estado = 'AGENDADO'
                      }else{
                        x.estado = 'ENTREGADO'
                      }
                     return x
                });
                this.totalOrders = data.data[1];

            });
        },
        onRowClick(item, shippingFee, slidingScaleFee) {
            this.$emit("row-click", item, shippingFee, slidingScaleFee);
        },
        async onChange(invoice) {
            this.showText = false
            let response = await CheckInOrderService.getIdOrder({ facturaNumber: invoice })
            let idOrder = response.data
      
            let response2 = await OrderService.getOrder(idOrder)
            let order = response2.data
            this.$emit("row-click", order, invoice)
        },
        showInputSearchInvoice() {
            let pathRoute = this.$router.currentRoute.path
            if (pathRoute === '/check-in-order') {
                this.showInput = true
            }
        },
        changeInitialDate() {
            let initialDate = moment(this.date).format('YYYY-MM-DD')
            this.minDate = initialDate
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') {
                if (!moment(this.date2).isSameOrAfter(initialDate)) {
                    this.date2 = this.minDate
                }
            } else {
                this.date2 = this.minDate
            }
        }
    }
};